/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .logo_brand[_ngcontent-%COMP%]{margin-top:2px;height:2rem}[_nghost-%COMP%]   .sidebar-flight-text[_ngcontent-%COMP%]{padding:20px 0 30px}@media (max-width:599px){[_nghost-%COMP%]   .logo_brand[_ngcontent-%COMP%]{height:1.8rem}[_nghost-%COMP%]   .sidebar-flight-text[_ngcontent-%COMP%]{text-align:center;padding:10px 0 20px}}"];
export { styles as styles };
